import useUser from "../../../../core/hooks/use-user";
import { toast } from "../../../../core/helpers/message-helper";
import Datatable from "../../../../core/ui/components/Datatable";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import useModal from "../../../../core/hooks/use-modal";
import FormVersionesContratos from "../components/form-versiones-contratos";
import { useState } from "react";
import swal from "sweetalert";
import { sweetAl } from "../../../../core/helpers/message-helper";
import {
    activarVersionesContratos,
    inactivarVersionesContratos,
} from "../../services/versiones-contratos-service";

const VersionesContratos = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState({});

    const modalVersionesContratos = useModal({
        title: "Agregar Versiones Contratos",
        data: { versionContrato: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSave = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("versionesContratosCrear")) {
        tableButtons.push({
            titleAttr: "Agregar Versiones Contratos",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalVersionesContratos.open({
                    title: "Agregar Versiones Contratos",
                    data: { versionContrato: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("versionesContratosEditar")) {
        tableButtons.push({
            titleAttr: "Editar Versiones Contratos",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalVersionesContratos.open({
                    title: "Editar Versiones Contratos",
                    data: { versionContrato: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("versionesContratosInactivar")) {
        tableButtons.push({
            titleAttr: "Inactivar Versiones Contratos",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar esta versión de contrato?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning(
                            "No se ha inactivado la versión de contrato"
                        );
                        break;
                    case "eliminar": {
                        const resp = await inactivarVersionesContratos(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar la Versión de Contrato"
                            );
                        }

                        sweetAl.success(
                            "La Versión de Contrato fue inactivado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("versionesContratosActivar")) {
        tableButtons.push({
            titleAttr: "Activar Versiones Contratos",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar esta Versión de Contrato?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning(
                            "No se ha activado la Versión de Contrato"
                        );
                        break;
                    case "activar": {
                        const resp = await activarVersionesContratos(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar la Versión de Contratos"
                            );
                        }

                        sweetAl.success(
                            "La Versión de Contrato fue activado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "versionContratos",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaVersionContrato",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/administrar/versionesContratos`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de las versiones de contratos"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "detalle" },
            { data: "html" },
            { data: "nombre_tipo_contrato_id" },
            { data: "nombre_tipo_version_id" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: 5,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Versiones De Contratos</div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover"
                    id="tablaVersionContrato"
                >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Detalle</th>
                            <th>HTML</th>
                            <th>Tipo Contrato</th>
                            <th>Tipo Versión</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormVersionesContratos
                modalState={modalVersionesContratos}
                onSave={onSave}
            />
        </ContentWrapper>
    );
};

export default VersionesContratos;
